import { redirect } from '@tanstack/react-router';
import { APP_PATHS } from '@/config/routes/app-paths';
import { isDashboardNavPathAccessible } from '@/config/routes/dashboard-paths';
import { useAppStore } from '@/stores/app-store';
import { ensureValidPath } from '@/utils/validate-path';

const buildAuthRedirect = () =>
  redirect({ to: ensureValidPath(APP_PATHS.home), search: { tab: 'signin' } });

const isAuthed = () => useAppStore.getState().isAuthenticated;

export const requireAuth = ({ location }: { location: { pathname: string } }) => {
  if (!isAuthed()) {
    throw buildAuthRedirect();
  }

  const appState = useAppStore.getState();
  if (
    !isDashboardNavPathAccessible(
      location.pathname,
      appState.currentUser,
      appState.selectedWholesalerId,
    )
  ) {
    throw redirect({ to: ensureValidPath(APP_PATHS.overview) });
  }
};
